// Shared visual language for homefront resources.
// Single source so the standalone v3 components and (later) the integrated
// HexBoard render identically. Functional palette, not final art.

export const RESOURCE_COLOR = {
    // The progression prototype's lot types (pacing lot_types.csv).
    timber:    '#6b4e26',
    metal:     '#6f7782',
    water:     '#2f6690',
    silicon:   '#8a83b8',
    sand:      '#c9ad6e',
    limestone: '#bdb8a6',
    // The older Grid resources.
    lumber: '#6b4e26',
    solar:  '#f5eec2',
    coal:   '#474747',
    natgas: '#3e8e55',
    oil:    '#9a6a00',
}

// Empty / undeveloped land.
export const EMPTY_COLOR = '#241f1a'

// One glyph per resource — used for the maker's land tool palette and for the
// assignment badge on a structure's center subplot (which resource it boosts).
export const RESOURCE_ICON = {
    lumber: '🪵',
    solar:  '☀️',
    coal:   '🪨',
    natgas: '⛽',
    oil:    '🛢️',
}

// Text color for labels sitting directly on a resource swatch. Solar is
// near-white, so a fixed white label disappears on it.
export function swatchTextColor(hex) {
    const r = parseInt(hex.slice(1, 3), 16)
    const g = parseInt(hex.slice(3, 5), 16)
    const b = parseInt(hex.slice(5, 7), 16)
    const luminance = 0.299 * r + 0.587 * g + 0.114 * b
    return luminance > 160 ? 'rgba(0,0,0,0.72)' : 'rgba(255,255,255,0.7)'
}

export function resourceColor(resourceType) {
    return resourceType ? (RESOURCE_COLOR[resourceType] ?? EMPTY_COLOR) : EMPTY_COLOR
}

// A much-subtler tint of a resource color (low alpha), so a revealed/damaged
// subplot only hints at what it was rather than filling a solid block. Returns
// null for empty land (no tint — the crater shadow alone marks it).
export function resourceTint(resourceType, alpha = 0.3) {
    if (!resourceType) return null
    const hex = RESOURCE_COLOR[resourceType] ?? EMPTY_COLOR
    const r = parseInt(hex.slice(1, 3), 16)
    const g = parseInt(hex.slice(3, 5), 16)
    const b = parseInt(hex.slice(5, 7), 16)
    return `rgba(${r}, ${g}, ${b}, ${alpha})`
}
